import { useGetLogo } from "./Logo.hooks";
import { Figure } from "./Logo.styles";

 type TLogoProps = {
   width?: string;
   height?: string;
   className?: string;
 };

function Logo({ width, height, className }: TLogoProps) {
  const logo = useGetLogo();

  return (
    <Figure
      style={{
        width,
        height,
      }}
      className={className}
    >
      <img height={height} width={width} src={logo} alt="company logo" />
    </Figure>
  );
}

export default Logo;
